import { useSupabase } from "@/app/supabase-provider";
import useSWR from "swr";

export function useUser() {
  const { supabase } = useSupabase();
  return useSWR("userData", async () => {
    return (await supabase.auth.getUser()).data.user;
  });
}
